import React from "react";

import Container from 'react-bootstrap/Container';

import "./ScheduleAppointment.scss";

export default function ScheduleAppointment() {
    return (
        <section className="schedule-section">
            <Container>
                <header className="schedule-header">
                    <span className="schedule-welcome">Welcome</span>
                    <h2 className="schedule-title">Schedule an Appointment</h2>
                    <hr className="schedule-divider" />
                </header>

                <div className="schedule-cards">
                    <div className="schedule-card schedule-card--new">
                        <span className="schedule-badge schedule-badge--new">New Patient</span>
                        <h3 className="schedule-card__heading">Start your care journey</h3>
                        <p className="schedule-card__body">
                            If you are a new patient, click the button below to schedule your initial evaluation.
                        </p>
                        <button
                            type="button"
                            className="schedule-btn schedule-btn--primary"
                            onClick={() => { window.open('https://betterdays.intakeq.com/booking', '_blank'); }}
                        >
                            Schedule an Appointment →
                        </button>
                    </div>

                    <div className="schedule-card schedule-card--existing">
                        <span className="schedule-badge schedule-badge--existing">Existing Patient</span>
                        <h3 className="schedule-card__heading">Are you already an established patient?</h3>
                        <p className="schedule-card__body">
                            Log into the patient portal below.
                        </p>
                        <button
                            type="button"
                            className="schedule-btn schedule-btn--secondary"
                            onClick={() => { window.open('https://betterdays.intakeq.com/portal', '_blank'); }}
                        >
                            Patient Portal →
                        </button>
                    </div>
                </div>
            </Container>
        </section>
    );
}
